function view (path) {
  return () => import(/* webpackChunkName: 'shared-v2' */ '@/views/shared/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RShared = [
  {
    path: '',
    name: 'shared.redirect',
    redirect: {
      name: 'shared.login'
    },
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/sign-in',
    component: view('SignIn'),
    name: 'shared.login',
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/components',
    component: view('public/Components'),
    name: 'shared.components',
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/auth/:provider/callback',
    component: view('SingleSignOn'),
    name: 'shared.sso',
    meta: {
      layout: 'sso'
    }
  },
  {
    path: '*',
    component: view('404'),
    name: 'shared.page-not-found',
    meta: {
      layout: 'auth'
    }
  }
]

const RSharedPrivate = [
  {
    path: '/account/settings',
    component: view('account-settings/Base'),
    name: 'shared.account.settings',
    meta: {
      breadcrumb: [
        {
          text: 'Account'
        },
        {
          text: 'Settings',
          active: true
        }
      ]
    }
  }
]

const RSharedDocuments = [
  {
    path: '/shared/documents/tutorials',
    component: view('documents/tutorials/Base'),
    name: 'shared.documents.tutorials',
    children: [
      {
        path: 'demand-officers',
        component: view('documents/tutorials/FSOfficers'),
        name: 'shared.documents.tutorials.demand-officers'
      },
      {
        path: 'area-managers',
        component: view('documents/tutorials/ASManagers'),
        name: 'shared.documents.tutorials.area-managers'
      }
    ],
    meta: {
      breadcrumb: [
        {
          text: 'Documents',
          to: '/'
        },
        {
          text: 'Tutorials',
          active: true
        }
      ]
    }
  },
  {
    path: '/shared/documents/customer-memos',
    component: view('documents/Downloadables'),
    name: 'shared.documents.customer-memos',
    meta: {
      breadcrumb: [
        {
          text: 'Documents',
          to: '/'
        },
        {
          text: 'Customer Memos',
          active: true
        }
      ]
    }
  }
]

export default RShared.concat(
  RSharedPrivate,
  RSharedDocuments
)
